// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"CenteredLoadingSpinner_loaderContainer__Xxjdo"};